export const INSTALLER_VENDOR_KIND = "installer-vendor";

/**
 * Installer Vendor — approved Master Account shell only.
 * No dedicated Installer product surface yet: Account + User Management.
 */
export const installerVendorExperience = {
  kind: INSTALLER_VENDOR_KIND,
  label: "Installer",
  landingPath: "/master-account/account",
  routeRules: [
    { prefix: "/master-account/account", capability: "tenant.settings.basic" },
    {
      prefix: "/master-account/user-management",
      capability: "tenant.users.manage",
    },
  ],
};
